function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3995 217.418H4.38963V201.398H11.2465C18.0572 201.398 21.378 204.027 21.378 209.408C21.378 214.789 18.6106 217.418 12.3995 217.418ZM4.38963 200.337V185.317H11.1542C17.104 185.317 19.9789 187.777 19.9789 192.85C19.9789 197.924 17.0732 200.337 11.0927 200.337H4.38963ZM16.7042 200.799C20.9014 199.892 23.8686 196.724 23.8686 192.85C23.8686 187.392 19.4101 184.271 11.6308 184.271H0.5V218.448H12.9222C20.6708 218.448 25.2983 215.02 25.2983 209.285C25.2983 204.704 22.0544 201.552 16.6889 200.783",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5132 205.594H33.8156L41.026 189.036L48.5132 205.594ZM54.2631 218.323L54.3246 218.477H58.3526L42.7479 183.962L42.6864 183.809H42.1483L27.0664 218.477H28.2041L33.3544 206.654H48.9898L54.2631 218.323Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65.0411 218.464H68.9307V204.335L81.1531 184.687L81.3991 184.287H80.2614L68.4695 203.059L56.8621 184.41L56.7852 184.287H52.4805L65.0411 204.381V218.464Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M101.876 201.445H123.569V218.464H127.458V184.287H123.569V200.399H101.876V184.287H97.9863V218.464H101.876V201.445Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M152.226 205.594H137.529L144.739 189.036L152.226 205.594ZM146.476 183.962L146.4 183.809H145.877L130.795 218.477H131.933L137.083 206.639H152.703L157.976 218.323L158.038 218.477H162.066L146.461 183.962H146.476Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M169.277 185.33H177.579C185.158 185.33 186.742 189.82 186.742 193.586C186.742 199.213 183.744 201.934 177.579 201.934H169.277V185.33ZM188.863 218.354L188.94 218.461H193.583L193.091 218.016C192.107 217.108 191.246 215.617 190.616 213.695L188.648 208.069C187.526 204.994 185.512 203.241 182.237 202.565C186.25 201.888 190.969 199.228 190.969 193.525C190.969 187.821 186.157 184.27 177.778 184.27H165.402V218.446H169.292V202.964H176.672C181.914 202.964 183.697 205.071 184.989 208.714L186.911 214.095C187.526 215.94 188.171 217.339 188.863 218.338",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M201.331 200.351V185.331H208.096C214.03 185.331 216.92 187.79 216.92 192.864C216.92 197.937 214.015 200.351 208.049 200.351H201.331ZM201.331 201.396H208.188C214.999 201.396 218.319 204.025 218.319 209.406C218.319 214.787 215.552 217.416 209.341 217.416H201.331V201.396ZM222.255 209.314C222.255 204.733 219.011 201.581 213.646 200.812C217.843 199.905 220.81 196.738 220.81 192.864C220.81 187.406 216.351 184.285 208.572 184.285H197.441V218.462H209.864C217.612 218.462 222.24 215.033 222.24 209.299",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M241.535 184.808C249.56 184.808 254.172 190.85 254.172 201.381C254.172 211.912 249.575 217.954 241.535 217.954C233.494 217.954 228.851 211.912 228.851 201.381C228.851 190.85 233.479 184.808 241.535 184.808ZM241.535 183.809C232.064 183.809 224.639 191.526 224.639 201.381C224.639 211.236 232.064 218.954 241.535 218.954C251.005 218.954 258.385 211.236 258.385 201.381C258.385 191.526 250.974 183.809 241.535 183.809Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M284.66 193.586C284.66 199.198 281.662 201.934 275.497 201.934H267.195V185.33H275.497C283.076 185.33 284.66 189.82 284.66 193.586ZM291.009 218.016C289.764 216.878 288.98 215.048 288.534 213.695L286.566 208.069C285.444 204.994 283.43 203.241 280.155 202.565C284.168 201.888 288.887 199.228 288.887 193.525C288.887 187.821 284.075 184.27 275.696 184.27H263.32V218.446H267.21V202.964H274.605C279.847 202.964 281.631 205.071 282.922 208.714L284.844 214.095C285.459 215.94 286.105 217.324 286.797 218.338L286.873 218.446H291.516L291.024 218L291.009 218.016Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M78.1995 228.533H47.4668V229.579H60.8883V262.71H64.7319V229.579H78.1995V228.533Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M93.1441 229.056C101.169 229.056 105.766 235.098 105.766 245.629C105.766 256.16 101.169 262.202 93.1441 262.202C85.1189 262.202 80.4605 256.16 80.4605 245.629C80.4605 235.098 85.0881 229.056 93.1441 229.056ZM93.1441 228.057C83.6583 228.057 76.248 235.774 76.248 245.629C76.248 255.484 83.6737 263.202 93.1441 263.202C102.615 263.202 109.994 255.484 109.994 245.629C109.994 235.774 102.584 228.057 93.1441 228.057Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M143.048 257.114L132.763 228.702L132.701 228.533H128.827L131.994 237.25L125.153 256.975L114.714 228.702L114.652 228.533H110.686L123.461 263.033L123.538 263.202H124.092L132.563 238.788L141.403 263.033L141.464 263.202H142.033L154.117 228.871L154.24 228.533H153.103L143.048 257.114Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M162.542 245.691H176.394V244.645H162.542V229.579H181.006V228.533H158.652V262.71H181.59V261.664H162.542V245.691Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M207.034 237.834C207.034 243.446 204.037 246.182 197.872 246.182H189.57V229.578H197.872C205.451 229.578 207.034 234.068 207.034 237.834ZM210.909 257.944L208.941 252.317C207.819 249.242 205.805 247.489 202.515 246.813C206.527 246.152 211.262 243.477 211.262 237.773C211.262 232.069 206.45 228.518 198.071 228.518H185.695V262.709H189.585V247.228H196.964C202.207 247.228 203.99 249.334 205.282 252.962L207.204 258.343C207.603 259.527 208.234 261.249 209.156 262.586L209.233 262.694H213.876L213.384 262.248C212.4 261.357 211.539 259.85 210.909 257.928",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M230.94 243.83L226.466 242.631C222.285 241.57 218.825 240.341 218.825 235.959C218.825 231.823 222.285 229.056 227.42 229.056C232.555 229.056 236.721 231.393 238.581 235.298L238.72 235.59L239.565 234.929L239.473 234.744C237.428 230.547 232.908 228.057 227.358 228.057C220.824 228.057 215.889 232.039 215.889 237.312C215.889 243.062 220.44 245.014 225.375 246.275L230.095 247.428C233.631 248.273 237.689 249.857 237.689 254.638C237.689 258.405 234.799 262.218 228.327 262.218C222.3 262.218 217.273 259.251 215.535 254.638L215.428 254.377L214.475 254.854L214.551 255.069C216.458 260.019 221.87 263.217 228.357 263.217C236.767 263.217 240.595 257.898 240.595 252.963C240.595 248.366 237.613 245.568 230.925 243.861",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M135.377 0.796875H58.0762V1.47333L67.7003 5.68582H128.689L128.643 16.3554H135.377V0.796875Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M134.054 65.9065H135.361V25.1191H128.643V111.844H135.361V68.351H134.054V65.9065Z",
  fill: "black"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M162.957 16.6014L162.926 5.68582H223.915L233.539 1.45796V0.796875H156.254V16.34H156.807C158.96 16.34 160.989 16.4477 162.972 16.6014",
  fill: "black"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M156.225 25.1191V65.8911L162.958 65.5375V25.1191H156.225Z",
  fill: "black"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M156.24 111.843H162.958V68.8418L156.225 68.3652L156.24 111.843Z",
  fill: "black"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M112.53 118.839V68.3505H126.075V65.906H112.53V18.8768H157.884C176.502 18.8768 185.557 26.61 185.557 42.5375C185.557 55.6669 179.254 63.1695 166.416 65.3526L162.957 65.5371V68.8425L166.416 69.0885C181.975 71.1332 189.877 79.3737 189.877 93.7023C189.877 111.075 181.206 118.839 161.789 118.839H162.957V121.314C185.403 120.684 198.748 110.383 198.748 93.4102C198.748 78.7587 187.879 68.9347 170.106 67.1821C184.127 65.1373 194.29 55.0519 194.29 42.5375C194.29 27.394 182.943 18.1542 162.973 16.6168V16.8013H156.254V16.3555H135.392H128.658H104.936V121.376H128.658V118.839H112.546H112.53Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M155.963 65.906H135.361V68.3505H155.517H155.963L156.224 68.3812V65.8906L155.963 65.906Z",
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M156.224 118.838H135.361V121.375H156.224V118.838Z",
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M135.361 16.3398H128.643V18.5691H135.361V16.3398Z",
  fill: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M136.284 65.9062H134.055V68.3507H136.284V65.9062Z",
  fill: "black"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M162.957 18.5845V17.6313C160.973 16.8626 158.944 16.3398 156.792 16.3398H156.238V18.5691H162.957V18.5845Z",
  fill: "black"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M156.225 68.3659L162.958 68.8425V65.5371L156.225 65.8907V68.3659Z",
  fill: "black"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M156.223 121.067H161.742C161.742 121.067 161.742 118.822 161.757 118.822H156.223V121.067Z",
  fill: "black"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M218.119 89.2433C215.828 104.663 208.771 118.9 197.548 130.123C187.862 139.809 175.932 146.404 162.941 149.51V121.314C162.219 121.329 161.527 121.375 160.789 121.375H156.223V150.816V157.304C173.534 155.06 189.554 147.234 202.099 134.674C215.274 121.498 223.269 104.51 225.037 86.1992H224.729L218.103 89.2433H218.119Z",
  fill: "black"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M162.957 121.313V118.838H156.238V121.375H160.804C161.542 121.375 162.234 121.328 162.957 121.313Z",
  fill: "black"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M128.642 149.51C115.651 146.404 103.721 139.809 94.0354 130.123C82.8585 118.946 75.8172 104.771 73.4957 89.4126L66.5312 86.2148C68.3146 104.525 76.2938 121.514 89.4693 134.674C102.015 147.219 118.034 155.044 135.345 157.304V121.375H128.627V149.51H128.642Z",
  fill: "black"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M135.361 118.838H128.643V121.067H135.361V118.838Z",
  fill: "black"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M135.361 118.838H128.643V121.375H135.361V118.838Z",
  fill: "black"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 264,
    viewBox: "0 0 292 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5d8ed0cd8bd0c33332f95a7c38c44a40.svg";
export { ForwardRef as ReactComponent };